<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rekam Medis" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data pasien</h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">
                data penanggung jawab {{ $route.params.id }}
              </h5>
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3">data pembayaran</h5>
              <FormRow
                v-for="row in rightFormBottom"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  type="submit"
                  @click="handleForm"
                  class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                >
                  <i class="material-symbols-outlined">check</i>
                  Simpan Data Pasien
                </button>
                <a
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  @click="() => goBack('/master/asuransi')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
import { leftForm, rightForm, rightFormBottom } from "@/data/PasienForm.js";
let data = {
  title: "Ubah Data Pasien",
  backBtn: "/pasien/detail/",
  actionBtn: [],
  breadcrumb: [
    { title: "Pasien", link: "/pasien" },
    { title: "Ubah Data Pasien", active: true },
  ],
};

export default {
  name: "PasienFormEdit",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: leftForm,
      rightForm: rightForm,
      rightFormBottom: rightFormBottom,
      fotoLama: "",
      formSet: {
        no_rm: "",
        id_provinsi: "",
        id_kota: "",
        id_kecamatan: "",
        id_kelurahan: "",
        id_provinsi_pj: "",
        id_kota_pj: "",
        id_kecamatan_pj: "",
        id_kelurahan_pj: "",
        id_asuransi: "",
        nama: "",
        jen_kelamin: "",
        gol_darah: "",
        tmp_lahir: "",
        tgl_lahir: "",
        pendidikan: "",
        nama_ibu: "",
        agama: "",
        status_nikah: "",
        no_telp: "",
        pekerjaan: "",
        jenis_id: "",
        no_id: "",
        alamat: "",
        pj_jenis: "",
        pj_nama: "",
        pj_pekerjaan: "",
        pj_alamat: "",
        asuransi_lain: "",
        no_peserta: "",
        foto: null,
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (self.formSet[key]) {
            if (!(key == "foto" && self.formSet[key] == self.fotoLama)) {
              formData.append(key, self.formSet[key]);
            }
          }
        });
        //console.log(this.formSet);
        try {
          let result = await this.$store.state.HTTP.post(
            "pasien/" + this.$route.params.id,
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.$router.push(`/pasien/detail/${this.$route.params.id}`);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },

    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }

      if (e.target.name == "id_provinsi" || e.target.name == "id_provinsi_pj") {
        let cities =
          e.target.name == "id_provinsi"
            ? this.leftForm[9].columns[1]
            : this.rightForm[4].columns[1];
        this.fetchCities(e.target.value, cities);
      } else if (e.target.name == "id_kota" || e.target.name == "id_kota_pj") {
        let districts =
          e.target.name == "id_kota"
            ? this.leftForm[10].columns[0]
            : this.rightForm[5].columns[0];
        this.fetchDistricts(e.target.value, districts);
      } else if (
        e.target.name == "id_kecamatan" ||
        e.target.name == "id_kecamatan_pj"
      ) {
        let subdistricts =
          e.target.name == "id_kecamatan"
            ? this.leftForm[10].columns[1]
            : this.rightForm[5].columns[1];
        this.fetchSubdistricts(e.target.value, subdistricts);
      } else if (e.target.name == "id_asuransi") {
        if (e.target.value == 1) {
          this.rightFormBottom[1].columns[0].type = "hidden";
          this.rightFormBottom[2].columns[0].type = "hidden";
          this.formSet["asuransi_lain"] = "";
          this.formSet["no_peserta"] = "";
          //console.log("uhuy1");
        } else if (e.target.value == 2) {
          this.rightFormBottom[1].columns[0].type = "hidden";
          this.rightFormBottom[2].columns[0].type = "text";
          this.formSet["asuransi_lain"] = "";
          //console.log("uhuy2");
        } else if (e.target.value == 3) {
          this.rightFormBottom[1].columns[0].type = "select";
          this.rightFormBottom[2].columns[0].type = "text";
          //console.log("uhuy3");
        }
      }
    },
    fetchProvinces: async function() {
      try {
        let result = await this.$store.state.HTTP.get("wilayah/provinsi");
        if (result.status == "200") {
          //console.log(result);
          let provinces = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[9].columns[0].options = provinces;
          this.rightForm[4].columns[0].options = provinces;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchCities: async function(id, city, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kota?id_provinsi=${id}`
        );
        if (result.status == "200") {
          //console.log(result);
          city.value = String(this.formSet[city.name]);
          city.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(9, 1, leftForm[9]);
            this.rightForm.splice(4, 1, rightForm[4]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchDistricts: async function(id, district, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kecamatan?id_kota=${id}`
        );
        if (result.status == "200") {
          //console.log(result);
          district.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(10, 1, leftForm[10]);
            this.rightForm.splice(5, 1, rightForm[5]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchSubdistricts: async function(id, subdistrict, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kelurahan?id_kecamatan=${id}`
        );
        if (result.status == "200") {
          //console.log(result);
          subdistrict.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(10, 1, leftForm[10]);
            this.rightForm.splice(5, 1, rightForm[5]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];

          return column;
        });
        return row;
      });
      this.rightForm = this.rightForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }

          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.rightFormBottom = this.rightFormBottom.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          if (column.name == "foto") {
            if (self.formSet[column.name] != self.fotoLama) {
              //console.log(self.formSet[column.name]);
              var reader = new FileReader();
              reader.onload = function(e) {
                column.value = e.target.result;
              };
              reader.readAsDataURL(self.formSet[column.name]);
            } else {
              self.formSet[column.name];
              //console.log(column.value);
              //console.log(self.fotoLama);
            }
          } else {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `pasien/${this.$route.params.id}?darurat=0`
        );
        //console.log(result);
        if (result.status == "200") {
          let pasien = result.data;
          //console.log(pasien);
          // this.formSet=pasien;
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            if (key == "foto") {
              self.formSet[key] = pasien["formatted_foto"];
              self.fotoLama = pasien["formatted_foto"];
            } else {
              self.formSet[key] = pasien[key];
            }
          });

          this.updateForm();
          //console.log(pasien);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.leftForm, this.rightForm, this.rightFormBottom].map(
        function(form) {
          form = form.map(function(row) {
            row.columns = row.columns.map(function(column) {
              if (self.formSet[column.name]) {
                column.value = self.formSet[column.name];
                if (column.name == "id_asuransi") {
                  self.handleChange({
                    target: {
                      value: column.value,
                      name: column.name,
                      type: column.type,
                    },
                  });
                }
              }
              return column;
            });
            return row;
          });
          return form;
        }
      );
      this.leftForm = forms[0];
      this.rightForm = forms[1];
      this.rightFormBottom = forms[2];
      this.fetchCities(
        String(this.formSet.id_provinsi),
        this.leftForm[9].columns[1],
        true
      );
      this.fetchCities(
        String(this.formSet.id_provinsi_pj),
        this.rightForm[4].columns[1],
        true
      );
      this.fetchDistricts(
        String(this.formSet.id_kota),
        this.leftForm[10].columns[0],
        true
      );
      this.fetchDistricts(
        String(this.formSet.id_kota_pj),
        this.rightForm[5].columns[0],
        true
      );
      this.fetchSubdistricts(
        String(this.formSet.id_kecamatan),
        this.leftForm[10].columns[1],
        true
      );
      this.fetchSubdistricts(
        String(this.formSet.id_kecamatan_pj),
        this.rightForm[5].columns[1],
        true
      );

      //console.log(leftForm)
      //console.log(rightForm)
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.fetchProvinces();
    this.displayData();
  },
};
</script>
